export { default as UserFinanceDebitFinBadgeLink } from './UserFinanceDebitFinBadgeLink';
